import React from 'react'

import Reflux from 'reflux-react-16'

import LoginStore from '../../stores/LoginStore.js'
import LoginActions from '../../actions/LoginActions.js'

import {Alert, Button, Card, Colors, H3, P} from '../../components/UI/index.js'
import {formSpacing, FormStack} from '../../components/UI/forms/index.js'
import {PasswordInput, PasswordRequirements, passwordReady} from '../../components/account/PasswordFields.js'
import LoadingPage from './LoadingPage.js'
import t from 'src/helpers/Languages.js'

export default class ResetPassword extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {password: '', password2: '', message: '', error: '', loading: false}
        this.store = LoginStore
    }

    componentDidMount() {
        document.title = t('changePassword')
    }

    onSubmit(event) {
        event.preventDefault()
        const {password, password2} = this.state
        const {token} = this.props.match.params

        // The button is only active when the requirements are met, the server checks them again
        if (!passwordReady(password, password2)) {
            return
        }

        this.setState({message: '', error: '', loading: true})

        LoginActions.resetPassword(token, password, (err) => {
            if (err) {
                this.setState({message: '', error: err, loading: false})
            } else {
                this.setState({message: t('resetPasswordDone'), error: '', loading: false})
            }
        })
    }

    onClickLogin() {
        window.location = '/login'
    }

    render() {
        const {password, password2, message, error, loading, brandingLoading, branding} = this.state

        if (brandingLoading) {
            return <LoadingPage />
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflowY: 'auto', background: Colors.backgroundNeutral}}>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <form style={{width: '100%', maxWidth: 474, padding: '0 12px'}} onSubmit={this.onSubmit.bind(this)}>
                        <Card shadow='true' style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 450, padding: 24, marginTop: 120, marginLeft: 'auto', marginRight: 'auto'}}>
                            <img style={{maxHeight: 128, maxWidth: 256, marginBottom: 50, objectFit: 'contain'}} src={branding?.mainLogo || '/images/VELOYDLOGO.png'} />

                            <H3 style={{marginBottom: 36}}>{t('changePassword')}</H3>

                            {!message &&
                                <>
                                    <P style={{maxWidth: 400, marginBottom: 24}}>{t('resetPasswordIntro')}</P>

                                    <FormStack style={{marginBottom: formSpacing.rowGap, width: '100%'}}>
                                        <PasswordInput label={t('newPassword')} value={password} onChange={(value) => this.setState({password: value})} />
                                        <PasswordInput label={t('repeatNewPassword')} value={password2} isInvalid={!!password2 && password2 !== password} onChange={(value) => this.setState({password2: value})} />
                                    </FormStack>

                                    <div style={{width: '100%', marginBottom: 12}}>
                                        <PasswordRequirements password={password} repeat={password2} />
                                    </div>
                                </>
                            }

                            {message && <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>}
                            {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                            {!message &&
                                <Button
                                    type='submit'
                                    style={{width: '100%', marginTop: 12}}
                                    color={branding?.color || Colors.brandColor}
                                    loading={loading}
                                    disabled={!passwordReady(password, password2)}
                                >
                                    {t('confirmButton')}
                                </Button>
                            }

                            <Button
                                style={{margin: 'auto', marginTop: 72}}
                                variant='text'
                                onClick={this.onClickLogin.bind(this)}
                            >
                                {t('login')}
                            </Button>
                        </Card>
                    </form>
                </div>
            </div>
        )
    }
}
